import { cardRef, defineGameCard, onResolve, planningTargets, targetStep, unitTarget, } from '../authoring/index.js';
import { addGrowth, alliedPlants, hasTrait, isLiveOnBoard, plannedUnitId, tableOf, } from './plant-helpers.js';
/**
 * Компостный круг: выбранный свой Лист погибает, после чего три единицы Роста
 * независимо и детерминированно распределяются между своими Растениями в его
 * бывшей локации через seeded random selection.
 */
export const CompostCycleCard = defineGameCard({
    id: 'compost_cycle',
    gameplay: {
        type: 'SPELL',
        cost: 1,
        planning: planningTargets([
            targetStep('leaf', unitTarget({
                side: 'ally',
                cardinality: { min: 1, max: 1 },
                where: ({ unit }) => unit.traits.includes('LEAF'),
            })),
        ]),
    },
    presentation: {
        name: 'Компостный круг',
        description: 'Выбранный ваш Лист погибает. 3 Роста случайно распределяются между вашими Растениями в этой локации.',
        glyph: {
            colors: ['#93A157', '#946836', '#10213A', '#9A4E26', '#7F3C25'],
            rows: [
                '....................',
                '.......111.111......',
                '........11.11.......',
                '.........212........',
                '..........1.........',
                '..........1.........',
                '..........1.11.11...',
                '....11.1..1..111....',
                '.....111..1...1.....',
                '......1.33133313....',
                '......134414441433..',
                '....331444144415453.',
                '...35414455555155553',
                '..344415554444445553',
                '.354455444444445553.',
                '.35454444444555533..',
                '35454444554555553...',
                '.335555544553333....',
                '...333355553........',
                '.......3333.........',
            ],
        },
    },
    role: 'playable',
    abilities: [
        onResolve({
            source: 'card_effect',
            dependencies: [cardRef('plant_growth')],
            run: (ctx) => {
                const leafId = plannedUnitId(ctx, 'leaf');
                const leaf = leafId === undefined ? null : ctx.q.instance(leafId);
                if (ctx.self === undefined || !isLiveOnBoard(leaf)
                    || leaf.controllerId !== ctx.self.controllerId
                    || !hasTrait(ctx, leaf.id, 'LEAF'))
                    return;
                const tableId = tableOf(leaf.cellId);
                ctx.ops.destroy(leaf.id);
                for (let point = 0; point < 3; point += 1) {
                    const candidates = alliedPlants(ctx, ctx.self.controllerId, { tableId }).map((plant) => plant.id);
                    if (candidates.length === 0)
                        break;
                    const selected = ctx.ops.selectRandomUnit(candidates, ctx.self.id);
                    if (selected === null)
                        break;
                    addGrowth(ctx, selected, 1, 'compost');
                }
            },
        }),
    ],
    ui: {
        mechanics: ['growth', 'death'],
        planning: { steps: { leaf: { label: 'Выберите свой Лист' } } },
    },
});
//# sourceMappingURL=compost_cycle.js.map